import '../../App.css';
import React, { useEffect } from 'react';
import { auth } from '../../firebase';
import { useState } from 'react';
import { signInAnonymously } from "firebase/auth";
import { logTweakingFeedback } from '../../logging.js';
import { TextField, Flex, Button, Form, Provider, defaultTheme, Text, Heading, Radio, RadioGroup, ContextualHelp, Content, CheckboxGroup, Checkbox, TextArea, Slider } from '@adobe/react-spectrum';

function PostTweakingForm({workerId, experiment, participantId, maxWordCount, specificExample, callbacks}) {
    // Results
    const [timeRanking, setTimeRanking] = useState(0);
    const [trailingRanking, setTrailingRanking] = useState(0);
    const [redactRanking, setRedactRanking] = useState(0);
    
    const [additionalComments, setAdditionalComments] = useState('');
    const [inputDevice, setInputDevice] = useState('');
    const [email, setEmail] = useState('');

    // Validation
    const [formValidated, setFormValidated] = useState(false);

    useEffect(() => {
        validateForm();
    }, [timeRanking, trailingRanking, redactRanking, email, inputDevice, additionalComments]);

    function validateForm() {
        if (timeRanking > 0 && trailingRanking > 0 && redactRanking > 0 && email !== '' && inputDevice !== '') {
            setFormValidated(true);
        }

        else {
            setFormValidated(false);
        }
    }

    function submitForm(e) {
        e.preventDefault();
        var results = {
            timestamp: Date.now(),
            participantId: participantId,
            workerId: workerId,
            experiment: experiment,
            timeRanking: timeRanking,
            trailingRanking: trailingRanking,
            redactRanking: redactRanking,
            inputDevice: inputDevice,
            additionalComments: additionalComments,
            email: email

        }

        logTweakingFeedback(participantId, results, callbacks);
    }

    return (
        <>    
            <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>             
                    <div id="textToRead" className='documentReader'>
                        <Heading level={1} width="100%" marginBottom="size-100" marginTop="size-0">Questionnaire</Heading>
                        <Text>Please answer the following questions about your experience highlighting using the different interaction techniques. <b>All questions are mandatory unless indicated otherwise.</b></Text>
                        <Form onSubmit={e => submitForm(e)}>
                            <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-200">Ranking</Heading> 
                            <Text>Rank the following interaction techniques from 1 to 3, with 1 being the most preferred and 3 being the least preferred. Ties are allowed.</Text>
                            {/* Time */}
                               <RadioGroup marginBottom="size-100" onChange={setTimeRanking} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">"Timeout" before highlighting text</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Most Preferred</Text>
                                {[...Array(3)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Least Preferred</Text>
                            </RadioGroup>  
                            
                            {/* Trailing */}
                            <RadioGroup marginBottom="size-100" onChange={setTrailingRanking} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Keeping your cursor inside a circle to highlight text</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Most Preferred</Text>
                                {[...Array(3)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Least Preferred</Text>
                            </RadioGroup>

                            {/* Redact */}
                            <RadioGroup marginBottom="size-100" onChange={setRedactRanking} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Obfuscating the document text when the mouse is down</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Most Preferred</Text>
                                {[...Array(3)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Least Preferred</Text>
                            </RadioGroup>

                            <Heading level={2} width="100%" marginBottom="size-100" marginTop="size-200">Other</Heading>
                           
                            {/* Input Device */}
                            <RadioGroup marginBottom="size-100" onChange={setInputDevice} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Which input device did you use during the experiment?</Heading>}>                     
                                <Radio value="mouse">Mouse</Radio>
                                <Radio value="trackpad">Trackpad</Radio>
                                <Radio value="mouseAndTrackpad">Both mouse and trackpad</Radio>
                                <Radio value="other">Other (describe below)</Radio>
                            </RadioGroup>

                            {/* Email for E-transfer */}
                            <TextField marginBottom="size-100" type="email" onChange={setEmail}  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Please enter your email address to receive your e-transfer</Heading>} />   

                            {/* Additional Comments */}
                            <TextArea marginBottom="size-100" onChange={setAdditionalComments} label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Do you have any additional comments? (optional)</Heading>} />                 
  
                            <Button variant='primary' type="submit" style='fill' marginTop="size-600" isDisabled={!formValidated}>Submit</Button>
                        </Form>
                    </div>
                </Flex>
            </Provider>
        </>
    );
}

export default PostTweakingForm;